"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _require = require('ramda'),
    either = _require.either,
    identity = _require.identity,
    merge = _require.merge,
    pathOr = _require.pathOr;

var parse = require('./parse');

var stringify = require('./stringify');

var E_BAD_RESOLVER_TYPE = new TypeError('The resolver must be a function');
var E_BAD_LOGGER_TYPE = new TypeError('Logger must be a function');
var E_NOT_INITIALIZED = new Error('I18n is not initialized yet');
var E_DATA_RESOLVER_NOT_INITIALIZED = new Error('The data resolver is not initialized yet');
var ALIAS_TOKEN = '@:';
var instance;
/**
 * Singleton class for string translation
 */

var I18n =
/*#__PURE__*/
function () {
  function I18n(translations) {
    _classCallCheck(this, I18n);

    // return stored instance if it exists
    if (instance) {
      instance.translations = merge(instance.translations, translations);
      return instance;
    }

    if (typeof window !== 'undefined' && window.localStorage) {
      this.noTranslations = JSON.parse(localStorage.getItem('NO_TRANSLATIONS', this.noTranslations));
    } // default resolver


    this.resolver = identity; // safety measure

    this.unsubscribeFromStore = function () {
      return undefined;
    }; // bind all methods


    this.attachLogger = this.attachLogger.bind(this);
    this.attachDataResolver = this.attachDataResolver.bind(this);
    this.attachKeyResolver = this.attachKeyResolver.bind(this);
    this.connectTo = this.connectTo.bind(this);
    this.detachKeyResolver = this.detachKeyResolver.bind(this);
    this.isExistingTranslation = this.isExistingTranslation.bind(this);
    this.populate = this.populate.bind(this);
    this.toggleTranslationKeys = this.toggleTranslationKeys.bind(this);
    this.translate = this.translate.bind(this);
    this.translationString = this.translationString.bind(this);
    this.setGlobals = this.setGlobals.bind(this);
    this.setPrefix = this.setPrefix.bind(this); // store translation

    this.translations = translations; // default prefix

    this.globals = {}; // default prefix

    this.prefix = null; // store instance in outer scope

    instance = this;
    return this;
  }

  _createClass(I18n, [{
    key: "attachKeyResolver",
    value: function attachKeyResolver(resolver) {
      if (typeof resolver === 'function') {
        this.resolver = resolver;
      } else {
        throw E_BAD_RESOLVER_TYPE;
      }
    }
  }, {
    key: "attachDataResolver",
    value: function attachDataResolver(resolver) {
      if (typeof resolver === 'function') {
        this.dataResolver = resolver;
      } else {
        throw E_BAD_RESOLVER_TYPE;
      }
    }
  }, {
    key: "attachLogger",
    value: function attachLogger(logger) {
      if (typeof logger === 'function') {
        this.logger = logger;
      } else {
        throw E_BAD_LOGGER_TYPE;
      }
    } // TODO: store translations in Redux Store and use I18n as global access point

  }, {
    key: "connectTo",
    value: function connectTo(store) {
      var _this = this;

      var stateName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'localization';
      this.state = store.getState();
      this.unsubscribeFromStore();
      this.unsubscribeFromStore = store.subscribe(function () {
        _this.state = store.getState();
      });
      this.stateName = stateName;
    }
  }, {
    key: "detachKeyResolver",
    value: function detachKeyResolver() {
      this.resolver = identity;
    }
  }, {
    key: "setGlobals",
    value: function setGlobals(globals) {
      this.globals = globals || {};
    }
  }, {
    key: "setPrefix",
    value: function setPrefix(prefix) {
      this.prefix = prefix;
    }
  }, {
    key: "getKey",
    value: function getKey(key) {
      return this.getPrefixedKey(this.resolver(key));
    }
  }, {
    key: "getPrefixedKey",
    value: function getPrefixedKey(key) {
      return this.prefix ? "".concat(this.prefix, ".").concat(key) : key;
    }
  }, {
    key: "isExistingTranslation",
    value: function isExistingTranslation(key) {
      return Boolean(this.translationString(this.getPrefixedKey(key)));
    }
  }, {
    key: "populate",
    value: function populate(translations) {
      this.translations = merge(this.translations, translations);
      return this.translations;
    }
  }, {
    key: "toggleTranslationKeys",
    value: function toggleTranslationKeys() {
      this.noTranslations = !this.noTranslations;

      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem('NO_TRANSLATIONS', JSON.stringify(this.noTranslations));
      }
    }
  }, {
    key: "translate",
    value: function translate(_key, locals, loose) {
      var key = this.getKey(_key);
      var raw = this.translationString(key, loose);

      if (!raw || this.noTranslations) {
        if (this.logger) {
          this.logger(key, pathOr('', ['state', this.stateName, 'language'], this));
        }

        return "[".concat(key, "]");
      }

      var variables = merge(this.globals, locals);

      if (typeof this.dataResolver === 'function') {
        return stringify(parse(raw), this.dataResolver(this.state), variables, loose);
      }

      throw E_DATA_RESOLVER_NOT_INITIALIZED;
    }
  }, {
    key: "translationString",
    value: function translationString(key, loose) {
      var translation = either(pathOr('', ['state', this.stateName, 'config', key]), pathOr('', ['translations', key]))(this); // if string starts with ALIAS_TOKEN, resolve this alias

      if (!loose && translation && translation.indexOf(ALIAS_TOKEN) === 0) {
        return this.translationString(translation.slice(ALIAS_TOKEN.length));
      }

      return translation;
    }
  }], [{
    key: "attachKeyResolver",
    value: function attachKeyResolver(resolver) {
      if (instance) {
        return instance.attachKeyResolver(resolver);
      }

      throw E_NOT_INITIALIZED;
    }
  }, {
    key: "attachDataResolver",
    value: function attachDataResolver(resolver) {
      if (instance) {
        return instance.attachDataResolver(resolver);
      }

      throw E_NOT_INITIALIZED;
    }
  }, {
    key: "attachLogger",
    value: function attachLogger(logger) {
      if (instance) {
        return instance.attachLogger(logger);
      }

      throw E_NOT_INITIALIZED;
    }
  }, {
    key: "connectTo",
    value: function connectTo(store, stateName) {
      if (instance) {
        return instance.connectTo(store, stateName);
      }

      throw E_NOT_INITIALIZED;
    }
  }, {
    key: "detachKeyResolver",
    value: function detachKeyResolver() {
      if (instance) {
        return instance.detachKeyResolver();
      }

      throw E_NOT_INITIALIZED;
    }
  }, {
    key: "setPrefix",
    value: function setPrefix(prefix) {
      if (instance) {
        return instance.setPrefix(prefix);
      }

      throw E_NOT_INITIALIZED;
    }
  }, {
    key: "setGlobals",
    value: function setGlobals(globals) {
      if (instance) {
        return instance.setGlobals(globals);
      }

      throw E_NOT_INITIALIZED;
    }
  }, {
    key: "isExistingTranslation",
    value: function isExistingTranslation(key) {
      if (instance) {
        return instance.isExistingTranslation(key);
      }

      throw E_NOT_INITIALIZED;
    }
  }, {
    key: "toggleTranslationKeys",
    value: function toggleTranslationKeys() {
      if (instance) {
        return instance.toggleTranslationKeys();
      }

      throw E_NOT_INITIALIZED;
    }
  }, {
    key: "populate",
    value: function populate(translations) {
      if (instance) {
        return instance.populate(translations);
      }

      throw E_NOT_INITIALIZED;
    }
  }, {
    key: "translate",
    value: function translate(key, locals) {
      if (instance) {
        return instance.translate(key, locals);
      }

      throw E_NOT_INITIALIZED;
    }
  }]);

  return I18n;
}();

module.exports = new I18n();
module.exports.I18n = I18n;
module.exports.attachKeyResolver = instance.attachKeyResolver;
module.exports.attachDataResolver = instance.attachDataResolver;
module.exports.attachLogger = instance.attachLogger;
module.exports.connectTo = instance.connectTo;
module.exports.detachKeyResolver = instance.detachKeyResolver;
module.exports.isExistingTranslation = instance.isExistingTranslation;
module.exports.populate = instance.populate;
module.exports.toggleTranslationKeys = instance.toggleTranslationKeys;
module.exports.translate = instance.translate;
module.exports.setGlobals = instance.setGlobals;
module.exports.setPrefix = instance.setPrefix;